import dataLayer from './dataLayer'

function illustrativeLinkClick (text) {
  dataLayer.add({
    event: "errorPageEvent",
    eventCategory: "navigering",
    eventAction: "klick på länk",
    eventLabel: text

  })
}

function pageLoad (code) {
  dataLayer.add({
    pageInformation: {
      errorCode : code
    }
  })
}

export default {
  illustrativeLinkClick,
  pageLoad
}
